module.exports={
	"Form": "TestSpecificationRequirementCreateManifest",
	"Scope": "TestSpecificationRequirement-Create",
	"Descriptors":
	{
		"TestSpecificationRequirementDetails.Name":
		{
			"Name": "Name",
			"Hash": "TestSpecificationRequirement-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "TestSpecificationRequirement-Create-Identity",
				"Group": "TestSpecificationRequirement-Create-Identity"
			}
		},
		"TestSpecificationRequirementDetails.IDTestSpecification":
		{
			"Name": "Test Specification",
			"Hash": "TestSpecificationRequirement-Create-IDTestSpecification",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "TestSpecificationRequirement-Create-Details",
				"Group": "TestSpecificationRequirement-Create-Details",
				"Entity": "TestSpecification",
				"SearchFields":
				[
					"Name",
					"Description"
				]
			}
		},
		"TestSpecificationRequirementDetails.IDTest":
		{
			"Name": "Test",
			"Hash": "TestSpecificationRequirement-Create-IDTest",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "TestSpecificationRequirement-Create-Details",
				"Group": "TestSpecificationRequirement-Create-Details",
				"Entity": "Test",
				"SearchFields":
				[
					"Name",
					"Description"
				]
			}
		},
		"TestSpecificationRequirementDetails.Ordinal":
		{
			"Name": "Ordinal",
			"Hash": "TestSpecificationRequirement-Create-Ordinal",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "TestSpecificationRequirement-Create-Details",
				"Group": "TestSpecificationRequirement-Create-Details"
			}
		},
		"TestSpecificationRequirementDetails.OperationType":
		{
			"Name": "Operation Type",
			"Hash": "TestSpecificationRequirement-Create-OperationType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "TestSpecificationRequirement-Create-Details",
				"Group": "TestSpecificationRequirement-Create-Details"
			}
		},
		"TestSpecificationRequirementDetails.ValueMinimum":
		{
			"Name": "Value Minimum",
			"Hash": "TestSpecificationRequirement-Create-ValueMinimum",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "TestSpecificationRequirement-Create-Details",
				"Group": "TestSpecificationRequirement-Create-Details"
			}
		},
		"TestSpecificationRequirementDetails.ValueMaximum":
		{
			"Name": "Value Maximum",
			"Hash": "TestSpecificationRequirement-Create-ValueMaximum",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "TestSpecificationRequirement-Create-Details",
				"Group": "TestSpecificationRequirement-Create-Details"
			}
		},
		"TestSpecificationRequirementDetails.ComputationTemplate":
		{
			"Name": "Computation Template",
			"Hash": "TestSpecificationRequirement-Create-ComputationTemplate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "TestSpecificationRequirement-Create-Details",
				"Group": "TestSpecificationRequirement-Create-Details"
			}
		},
		"TestSpecificationRequirementDetails.OutcomeType":
		{
			"Name": "Outcome Type",
			"Hash": "TestSpecificationRequirement-Create-OutcomeType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "TestSpecificationRequirement-Create-Details",
				"Group": "TestSpecificationRequirement-Create-Details"
			}
		},
		"TestSpecificationRequirementDetails.OutcomeTargets":
		{
			"Name": "Outcome Targets",
			"Hash": "TestSpecificationRequirement-Create-OutcomeTargets",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "TestSpecificationRequirement-Create-Details",
				"Group": "TestSpecificationRequirement-Create-Details"
			}
		},
		"TestSpecificationRequirementDetails.ComputationSuccessOutcome":
		{
			"Name": "Computation Success Outcome",
			"Hash": "TestSpecificationRequirement-Create-ComputationSuccessOutcome",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "5",
				"Width": 4,
				"Section": "TestSpecificationRequirement-Create-Details",
				"Group": "TestSpecificationRequirement-Create-Details"
			}
		},
		"TestSpecificationRequirementDetails.ComputationFailureOutcome":
		{
			"Name": "Computation Failure Outcome",
			"Hash": "TestSpecificationRequirement-Create-ComputationFailureOutcome",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "5",
				"Width": 4,
				"Section": "TestSpecificationRequirement-Create-Details",
				"Group": "TestSpecificationRequirement-Create-Details"
			}
		},
		"TestSpecificationRequirementDetails.PrecompiledSolver":
		{
			"Name": "Precompiled Solver",
			"Hash": "TestSpecificationRequirement-Create-PrecompiledSolver",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "5",
				"Width": 4,
				"Section": "TestSpecificationRequirement-Create-Details",
				"Group": "TestSpecificationRequirement-Create-Details"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "TestSpecificationRequirement-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "TestSpecificationRequirement-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "TestSpecificationRequirement-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "TestSpecificationRequirement-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
